export default __webpack_public_path__ + "static/media/zoomIn.54a76f0d.svg";